import basePath from "base_path";

import ActionTypes, {MattersActionTypes} from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {Matter} from "common/types/matter";

export type MattersFetchAction = {
  type: MattersActionTypes["MATTERS_FETCH"]["SUCCESS"];
  payload: Matter[];
};

export default function fetchMatters(requestor) {
  return createReduxPromiseAction(
    ActionTypes.MATTERS_FETCH,
    (organisationId: OrganisationId, projectId: ProjectId) => {
      return requestor
        .get(
          `${basePath}/organisation/${organisationId}/project/${projectId}/matter`,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
